import { Input, Output, ChangeDetectorRef, ComponentFactoryResolver, ViewContainerRef, Component, EventEmitter } from "@angular/core";
import { SharedService } from '../shared';
import { Options } from 'ngx-slider-v2';
import { TherapieTabsEnum, TitrationEventType, ITitrationLogParams, ITitrationPreLoadParams } from './titration-rechner.model';

import { TitrationRechnerInfoComponent } from './titration-rechner-info';
import { TitrationRezeptComponent } from './titration-rezept';
import { TitrationRechnerPopupComponent } from './titration-rechner-popup';
import { PartnerNamesEnum } from "../medizinisches-cannabisantrag";

declare var jsPanel: any;
export const DE = 'de';

@Component({
    template: ''
})
export class TitrationTherapieCommonComponent {
    @Input() partnerName: string = "";
    ActiveTherapieTab: TherapieTabsEnum = null;
    PartnerNamesEnum = PartnerNamesEnum;

    expandedContent: boolean = false;
    jsPanelPopup: any;

    @Input() thcKonzentrationInput: any = "";
    artDerDorierungInput: any = 0.05;
    verschreibungsmengeInput: any = 20;

    morgensVal: number = 10;
    mittagsVal: number = 0;
    abendsVal: number = 10;
    zurNachtVal: number = 0;

    @Input() KolbenpipetteValue = 0;
    @Input() DosierpumpeValue = 0;

    @Input() thcKonzentrationList: any[] = [];
    @Input() artDerDorierungList: any[] = [];
    @Input() verschreibungsmengeList: any[] = [];

    @Input() D_thcKonzentrationList: any[] = [];
    @Input() D_artDerDorierungList: any[] = [];
    @Input() D_verschreibungsmengeList: any[] = [];

    @Input() productList: any[] = [];
    @Input() productNameInput: any = null;

    @Output() onChooseProductName: EventEmitter<any> = new EventEmitter();


    get isPrivatePage() {
        return this.partnerName && this.partnerName.length > 0 ? true : false;
    }

    get rechnerPanelWidth() {
        return Math.min(1200, window.innerWidth * 0.9);
    }

    get rechnerPanelHeight() {
        return Math.min(900, window.innerHeight * 0.9);
    }


    get rezeptPanelWidth() {
        return Math.min(1100, window.innerWidth * 0.9);
    }

    get rezeptPanelHeight() {
        return Math.min(900, window.innerHeight * 0.9);
    }

    get prePopupPanelWidth() {
        return Math.min(800, window.innerWidth * 0.9);
    }

    get prePopupPanelHeight() {
        return Math.min(500, window.innerHeight * 0.9);
    }

    get printableHTML() {
        return document.getElementById("titration-plan-block").outerHTML;
    }

    get thcKonzentrationObj() {
        return this.thcKonzentrationList.find(a => a.ProductName == this.thcKonzentrationInput)
    }

    get thcKonzArt() {
        /*return this.thcKonzentrationObj?.ART || this.thcKonzentrationObj?.ProductName || "Cannabisextrakt";*/
        return this.thcKonzentrationObj?.ProductName || "Cannabisextrakt";
    }

    get thcMgML() {
        var THC = this.thcKonzentrationObj.THC;
        if (typeof THC == 'number') {
            return THC;
        }
        return parseInt(THC.match(/\d+/), 10) || 1;
    }

    get cbdMgML() {
        var CBD = this.thcKonzentrationObj.CBD;
        if (typeof CBD == 'number') {
            return CBD;
        }
        return parseInt(CBD.match(/\d+/), 10) || 1;
    }

    get selectedProduct() {
        return this.productList.find(a => a.ProductName == this.productNameInput);
    }

    get productName() {
        if (this.selectedProduct) {
            return this.selectedProduct.ProductName
        }
        return "";
    }

    get productArt() {
        if (this.selectedProduct) {
            /*return this.selectedProduct.ART || this.productName*/
            return this.productName
        }
        return this.thcKonzArt;
    }

    get productTHC() {
        if (this.selectedProduct && this.selectedProduct.THC) {
            var THC = this.selectedProduct.THC;
            if (typeof THC == 'number') {
                return THC;
            }
            return parseInt(THC.match(/\d+/), 10) || 1;
        }
        return this.thcMgML;
    }

    get productCBD() {
        if (this.selectedProduct && this.selectedProduct.CBD) {
            var CBD = this.selectedProduct.CBD;
            if (typeof CBD == 'number') {
                return CBD;
            }
            return parseInt(CBD.match(/\d+/), 10) || 1;
        }
        return this.cbdMgML;
    }

    get totalDosierungsVal() {
        return this.morgensVal + this.mittagsVal + this.abendsVal + this.zurNachtVal;
    }

    get SESSION_PRELOAD_POPUP() {
        return `session_preload_popup_${this.partnerName ? this.partnerName : "standard"}`;
    }

    get sessionPreLoadPopupData() {
        let data = sessionStorage.getItem(this.SESSION_PRELOAD_POPUP);
        if (data && data.length > 10) {
            return JSON.parse(data) as ITitrationPreLoadParams;
        }
        return null;
    }

    get isShowPreLoadPopup() {
        return this.sessionPreLoadPopupData == null;
    }

    get ProductTHCText() {
        switch (this.partnerName) {
            case PartnerNamesEnum.DOSIS_EQ_TILRAY:
            case PartnerNamesEnum.DOSIS_EQ_420_PHARMA:
                return "Produktauswahl";
            case PartnerNamesEnum.DOSIS_EQ_HORMOSAN:
                return "CAM Auswahl";
            default:
                return "THC Konzentration";
        }
    }

    constructor(protected cd: ChangeDetectorRef,
        protected vcr: ViewContainerRef,
        protected resolver: ComponentFactoryResolver,
        protected sharedService: SharedService) {

    }

    dosierungsSchemaOptions(Name: string): Options {
        let ceil = 10;
        let step = 1;
        if (this.ActiveTherapieTab == TherapieTabsEnum.FORTSETZEN) {
            ceil = 30;
            step = 1;
            if (this.artDerDorierungInput == this.KolbenpipetteValue) {
                ceil = 1.5;
                step = 0.05;
            }
        }
        let Color = "#1D90F6";
        switch (this.partnerName) {
            case PartnerNamesEnum.DOSIS_EQ_TILRAY:
                Color = "#0051ce";
                break;
            case PartnerNamesEnum.DOSIS_EQ_HORMOSAN:
                Color = "#4A1934";
                break;
            case PartnerNamesEnum.DOSIS_EQ_420_PHARMA:
                switch (Name) {
                    case "morgens":
                        Color = "#B4C94A";
                        break;
                    case "mittags":
                        Color = "#889B23";
                        break;
                    case "abends":
                        Color = "#5F9D0A";
                        break;
                    case "zur Nacht":
                        Color = "#0E2E1D";
                        break;
                }
                break;

        }
        return {
            floor: 0,
            ceil: ceil,
            step: step,
            vertical: true,
            autoHideLimitLabels: true,
            hideLimitLabels: true,
            hidePointerLabels: true,
            showSelectionBar: true,
            getSelectionBarColor: (value: number): string => {
                return Color;
            },
            getPointerColor: (value: number): string => {
                if (value > 0) {
                    return Color;
                }
                return "#FFFFFF";
            },
        }
    }

    fnSetCommonSliderValues(type: 'STANDARD' | 'BALANCE' | 'NACHTS' = 'STANDARD') {
        switch (type) {
            case 'STANDARD':
                this.morgensVal = 10;
                this.mittagsVal = 0;
                this.abendsVal = 10;
                this.zurNachtVal = 0;
                break;
            case 'BALANCE':
                this.morgensVal = 5;
                this.mittagsVal = 5;
                this.abendsVal = 5;
                this.zurNachtVal = 5;
                break;
            case 'NACHTS':
                this.morgensVal = 0;
                this.mittagsVal = 0;
                this.abendsVal = 2;
                this.zurNachtVal = 6;
                break;
        }
    }

    fnSetCommonDefaultValues() {
        this.fnSetCommonSliderValues();
    }

    _inputChangeProduct() {
        this.onChooseProductName.emit(this.productNameInput);
    }

    fnPrintData(Params: ITitrationLogParams[]) {
        this.sharedService.printHTMLData(this.printableHTML, {
            headCss: true,
            extraCss: `<style>.titration-plan-block {max-width: 100%; }.print-view-close.show-on-blank{display:flex !important;}.header-button-icon-contianer.button-on-blank{width:62px !important;}</style>`
        });
        this.generateTitrationLogParams(TitrationEventType.PrintPlan, Params);
    }

    fnShowCommonRechnerInfoPopup(accNumber, ActiveTherapieTab) {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let component = this;
        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(TitrationRechnerInfoComponent);
        const componentRef = this.vcr.createComponent(factory);
        componentRef.instance.partnerName = this.partnerName;
        componentRef.instance.accNumber = accNumber;
        componentRef.instance.ActiveTherapieTab = ActiveTherapieTab;
        componentRef.instance.isPrivatePage = this.isPrivatePage;
        const element = componentRef.location.nativeElement;

        var headerTitle = "CAM DOSIS EQ";
        switch (this.partnerName) {
            case PartnerNamesEnum.DOSIS_EQ_TILRAY:
                headerTitle = "Tilray Titration";
                break;
            case PartnerNamesEnum.DOSIS_EQ_HORMOSAN:
                headerTitle = "Hormosan CAM DOSIS EQ";
                break;
            case PartnerNamesEnum.DOSIS_EQ_420_PHARMA:
                headerTitle = "420 Pharma CAM DOSIS EQ";
                break;
            default:
                break;
        }

        this.jsPanelPopup = jsPanel.create({
            theme: 'dark',
            css: {
                panel: this.partnerName
            },
            //footerToolbar: [
            //    '<button type="button" class="btn btn-sm btn-danger mr-2" data-type="close">Stornieren</button>',
            //    '<button type="button" class="btn btn-sm btn-success" data-type="ok">Ok</button>'
            //],
            panelSize: {
                width: () => { return component.rechnerPanelWidth; },
                height: () => { return component.rechnerPanelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: headerTitle + " : " + (ActiveTherapieTab === TherapieTabsEnum.STARTEN ? 'Therapie Starten' : 'Therapie Fortsetzen'),
            onwindowresize: true,
            onstatuschange: (panel, status) => {
            },
            resizeit: {
                resize: (panel, paneldata, event) => {
                }
            },
            content: element,
            callback: function (panel) {
                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "ok":
                                panel.close();
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup, this.partnerName);
    }

    fnShowCommonRezeptPopup(Params: ITitrationLogParams[], dosierungText: any) {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let arzneimitText = "";
        if (this.isPrivatePage) {
            arzneimitText = this.productNameInput;
        } else {
            arzneimitText = this.thcKonzentrationInput;
        }
        let component = this;
        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(TitrationRezeptComponent);
        const componentRef = this.vcr.createComponent(factory);
        componentRef.instance.partnerName = this.partnerName;
        componentRef.instance.ActiveTherapieTab = this.ActiveTherapieTab;
        componentRef.instance.arzneimitText = arzneimitText;
        componentRef.instance.dosierungText = dosierungText;

        componentRef.instance.onBtnCLick.subscribe((key: TitrationEventType) => {
            this.generateTitrationLogParams(key, Params);
        })

        const element = componentRef.location.nativeElement;

        this.jsPanelPopup = jsPanel.create({
            theme: 'dark',
            css: {
                panel: this.partnerName
            },
            //footerToolbar: [
            //    '<button type="button" class="btn btn-sm btn-danger mr-2" data-type="close">Stornieren</button>',
            //    '<button type="button" class="btn btn-sm btn-success" data-type="ok">Ok</button>'
            //],
            panelSize: {
                width: () => { return component.rezeptPanelWidth; },
                height: () => { return component.rezeptPanelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: 'Rezeptvorlage',
            onwindowresize: true,
            onstatuschange: (panel, status) => {
            },
            resizeit: {
                resize: (panel, paneldata, event) => {
                }
            },
            content: element,
            callback: function (panel) {
                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "ok":
                                panel.close();
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup, this.partnerName);
    }

    fnShowPreLoadQuestionPopup(EventType: TitrationEventType, Params: ITitrationLogParams[]) {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let component = this;
        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(TitrationRechnerPopupComponent);
        const componentRef = this.vcr.createComponent(factory);
        componentRef.instance.partnerName = this.partnerName;
        componentRef.instance.onBtnCLick.subscribe((event: ITitrationPreLoadParams) => {
            sessionStorage.setItem(this.SESSION_PRELOAD_POPUP, JSON.stringify(event));
            this.jsPanelPopup.close();
            document.getElementsByTagName("body")[0].classList.remove("overflow-hidden");
            this.generateTitrationLogParams(EventType, Params);
        })
        document.getElementsByTagName("body")[0].classList.add("overflow-hidden");
        const element = componentRef.location.nativeElement;

        this.jsPanelPopup = jsPanel.create({
            id: 'jsPreLoadPopup',
            css: {
                panel: this.partnerName
            },
            header: false,
            dragit: false,
            resizeit: false,
            panelSize: {
                width: () => { return component.prePopupPanelWidth; },
                height: () => { return component.prePopupPanelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            content: element
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup, this.partnerName);
    }

    generateTitrationLogParams(EventType: TitrationEventType, Params: ITitrationLogParams[]) {
        if (this.isPrivatePage) {
            Params.push({ Name: "Produktauswahl", Value: this.productNameInput });
        }

        Params.push({ Name: "THC Konzentration", Value: this.thcKonzentrationInput });
        Params.push({ Name: "Dosierungsart", Value: this.artDerDorierungInput });
        Params.push({ Name: "Verschreibungsmenge", Value: this.verschreibungsmengeInput });

        Params.push({ Name: "morgens", Value: this.morgensVal });
        Params.push({ Name: "mittags", Value: this.mittagsVal });
        Params.push({ Name: "abends", Value: this.abendsVal });
        Params.push({ Name: "zur Nacht", Value: this.zurNachtVal });

        this.saveTitrationLog(EventType, Params);
    }

    saveTitrationLog(EventType: TitrationEventType, Params: ITitrationLogParams[]) {
        let PageName = this.partnerName || "Standard";
        let PageUrl = window.location.href;
        let payload: any = {};

        let data = this.sessionPreLoadPopupData;
        if (data) {
            if (data.BundeslandText) {
                Params.push({ Name: "BundeslandText", Value: data.BundeslandText });
            }
            if (data.FachrichtungText) {
                Params.push({ Name: "FachrichtungText", Value: data.FachrichtungText });
            }
            payload = {
                ...payload,
                "Fachrichtung": data.Fachrichtung,
                "Bundesland": data.Bundesland
            }
        }

        payload = {
            ...payload,
            PageName: PageName,
            PageUrl: PageUrl,
            EventType: EventType,
            ActiveTab: this.ActiveTherapieTab,
            Params: Params
        }
        this.sharedService.saveTitrationLog(payload);
    }
}
